import React from 'react';
import './About.css';
import heroImage from '../images/Hero - AdobeStock_1204602389.png';
import missionImage from '../images/About us Mission image.png';
import CTASection from '../components/CTASection';

function About() {
  return (
    <div className="about-page">
     <section className="about-hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <p className="hero-tagline">Zibit helps your team plan smarter, execute better, and prove results.</p>
            <h1>We Help Teams Make Trade Shows Work Better.</h1>
            <button className="cta-button">Get Started</button>
          </div>
        </div>
      </section>

      <section className="about-content">
        {/* TODO: Replace heroImage with real team/founder photo before launch — currently AI placeholder */}
          <div className="about-section">
            <img src={heroImage} alt="Team" className="about-image" />
            <div className="about-text">
              <h2>About Us</h2>
              <p>
                With over 20 years of managing 30+ trade shows each year, the founders of Zibit knew 
                there was a better way to keep track of everything that goes into having successful trade 
                shows. With increased pressure to ensure each show was bigger and better each year, 
                we've systematically developed a system to improve the success of each event year over year.
              </p>
            </div>
          </div>

          <div className="quiz-banner">
            <p>Is your trade-show spend pulling its weight?</p>
            <p className="quiz-cta">Take our 2-minute ROI Quiz and get your score now.</p>
            <div className="quiz-link">Take Quiz 📋</div>
          </div>

          <div className="mission-section">
            <div className="mission-text">
              <h2>Mission</h2>
              <p>
                Our Mission is to simplify trade show planning and execution so teams can work smarter, 
                impress leadership with clear results, and focus on creating memorable, high-impact experiences.
              </p>
            </div>
            <img src={missionImage} alt="Mission" className="mission-image" />
          
        </div>
      </section>

      <CTASection />
    </div>
  );
}

export default About;